module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving9-168b21a090215a332cff524611e94101.jpg";